import { useEffect } from "react";
import { isMIUI, isMobile } from "react-device-detect";
import { ParallaxProvider, Parallax } from "react-scroll-parallax";

const About = () => {
  return (
    <div className="aboutcontainer">
      <div className="scrollcontrol" id="about"></div>
      <div className="accentone"></div>
      <div className="left">
        <ParallaxProvider>
          <Parallax speed={-5}>
            <img
              src="https://images.unsplash.com/photo-1505798577917-a65157d3320a?q=80&w=3540&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
              alt=""
            />
          </Parallax>
        </ParallaxProvider>
      </div>
      {!isMobile && (
        <>
          <div className="accenttwo"></div>
          <div className="biorightpic">
            <ParallaxProvider>
              <Parallax speed={-5}>
                <img
                  src="https://images.unsplash.com/photo-1503387762-592deb58ef4e?q=80&w=3431&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                  alt=""
                />
              </Parallax>
            </ParallaxProvider>
          </div>
        </>
      )}
      <div className="right">
        <h5>Our Mission</h5>
        <p>
          ZIEL delivers quality solutions that ensure an exceptional customer
          experience and uphold the highest standards of integrity and ethics.
          We pledge to complete our work on time and within budget.
        </p>
      </div>
      <div className="right bio">
        <h5>Who We Are</h5>
        <p>
          ZIEL is a family owned company. Daniel Rodriguez and Scott Copas met
          over 10 years ago while working on some residential home projects.
          They stayed in touch over the years and continued to work on projects
          together. As time evolved they started rehabbing homes together.
          People began to take notice of their work and started inquiring if
          they would work on their home. Daniel and Scott decided It was time to
          form a company. ZIEL, which is the initials of their children’s first
          names, was officially formed. Daniel brings over 30 years of
          construction experience and Scott brings over 30 years of financial
          services experience. Together their goal is to deliver quality
          solutions that insure an exceptional customer experience, uphold the
          highest standards of integrity and ethics, while staying on budget and
          time frame for the customer.
        </p>
      </div>
    </div>
  );
};

export default About;
